import { Reveal, SectionTag } from "./Reveal";

const PILLARS = [
  { n: "01", name: "Source", text: "Find appropriate supply through trusted partners." },
  { n: "02", name: "Procure", text: "Compare commercial options and support negotiation." },
  { n: "03", name: "Coordinate", text: "Manage documentation, suppliers and logistics." },
  { n: "04", name: "Manage", text: "Handle recurring and multi-location requirements." },
  { n: "05", name: "Deliver", text: "Coordinate delivery according to agreed terms." },
];

export default function ServicesStrip() {
  return (
    <section id="services" data-testid="services-strip" className="relative py-24 md:py-28 border-y border-white/5">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <SectionTag number="02" label="What Ajemi Does" />
          <h2 className="font-outfit text-3xl md:text-5xl font-extralight tracking-tight text-white max-w-3xl">
            We take the heavy lifting <span className="text-gold">out of energy procurement.</span>
          </h2>
        </Reveal>
        <div className="mt-14 grid grid-cols-2 md:grid-cols-5 gap-px bg-white/5 rounded-2xl overflow-hidden border border-white/8">
          {PILLARS.map((p, i) => (
            <Reveal key={p.n} delay={0.06 * i} className="col-span-1">
              <div
                data-testid={`service-pillar-${p.name.toLowerCase()}`}
                className="group h-full bg-ink px-6 py-8 hover:bg-surface transition-colors duration-500"
              >
                <span className="font-outfit text-xs text-gold/70">{p.n}</span>
                <h3 className="font-outfit text-xl font-light text-white mt-3 group-hover:text-gold transition-colors duration-300">
                  {p.name}
                </h3>
                <p className="text-xs text-white/45 mt-2 leading-relaxed">{p.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
